export default __webpack_public_path__ + "static/media/m4.810183a7.jpg";